export default __webpack_public_path__ + "static/media/questionbox-icon.c0708dd4.svg";